export default __webpack_public_path__ + "static/media/SURVIVE_3.83de7358.jpg";